import { TransactionStatus } from '../../../const/transactionStatus';
var getDisputeInfoPageName = function (caseStatus) {
    // TODO: double check analytics
    switch (caseStatus) {
        case TransactionStatus.SET_1:
            return { pageName: 'opened' };
        case TransactionStatus.SET_2:
        case TransactionStatus.SET_3:
        case TransactionStatus.SET_4:
        case TransactionStatus.SET_5:
        case TransactionStatus.SET_6:
        case TransactionStatus.SET_7:
        case TransactionStatus.SET_22:
            return { pageName: 'under-review' };
        case TransactionStatus.SET_21:
            return {
                pageName: 'pending',
                pageSubFunction: 'cancel-pending'
            };
        case TransactionStatus.SET_8:
        case TransactionStatus.SET_14:
        case TransactionStatus.SET_15:
        case TransactionStatus.SET_16:
        case TransactionStatus.SET_17:
        case TransactionStatus.SET_18:
        case TransactionStatus.SET_20:
            return { pageName: 'complete', pageSubFunction: 'customer-responsible' };
        case TransactionStatus.SET_11:
        case TransactionStatus.SET_19:
            return { pageName: 'complete', pageSubFunction: 'no-longer-disputing' };
        case TransactionStatus.SET_9:
        case TransactionStatus.SET_10:
        case TransactionStatus.SET_12:
        case TransactionStatus.SET_13:
        case TransactionStatus.SET_23:
        case TransactionStatus.SET_24:
        case TransactionStatus.SET_25:
            return { pageName: 'complete', pageSubFunction: 'resolved' };
        default:
            throw new Error("could not get page name for ".concat(caseStatus));
    }
};
export default getDisputeInfoPageName;
//# sourceMappingURL=helpers.js.map